import React from 'react';

import { DealBase } from 'core/lib';

export const DealBaseDetailsContext = React.createContext<DealBase | Partial<DealBase> | null>(null);
